import axios from 'axios'

export const CeremonyService = {
    loadCeremony: () => {
        return new Promise(
            function (resolve, reject) {
                axios.get('/ceremony')
                    .then((response) => {
                        if (response.status === 200) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            })
    },
    saveCeremony: (payload) => {
        return new Promise(
            function (resolve, reject) {
                axios.put('/ceremony', payload)
                    .then((response) => {
                        if (response.status === 200) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            }
        )
    }
}



// WEBPACK FOOTER //
// ./src/services/ceremony-service.js